import Text from "src/components/Text";

export const Deadline = () => {
  return (
    <>
      <br />
      <Text
        className={`festival-deadline`}
        size={`xn`}
        width={`semibold`}
      >{`Zakoupená lekce vám zůstane i po skončení festivalu.`}</Text>
    </>
  );
};
